// Stepper keys
export const STEP1 = 'select-your-preferences';
export const STEP2 = 'review-your-results';
